<template>
  <div class="leftSidebar-main">
    <div class="nav-menu-body" id="headerMenu">
      <el-menu
        class="sidebar-el-menu"
        :default-active="onRoutes"
        background-color="#2c306d"
        text-color="#fff"
        active-text-color="#fff"
        unique-opened
        router
      >
        <template v-for="item in routesLists">
          <template v-if="item.children">
            <el-submenu :index="item.index" :key="item.index">
              <template slot="title">
                <i :class="item.menuIcon"></i>
                <span>{{ item.meta != null ? item.meta.title : ''}}</span>
              </template>
              <template v-for="subItem in item.children">
                <el-submenu v-if="subItem.children" :index="subItem.name" :key="subItem.name">
                  <template slot="title">{{ subItem.meta != null ? subItem.meta.title : '' }}</template>
                  <el-menu-item
                    v-for="(threeItem, i) in subItem.children"
                    :key="i"
                    :index="threeItem.name"
                  >{{ threeItem.meta != null ? threeItem.meta.title : '' }}</el-menu-item>
                </el-submenu>
                <el-menu-item
                  v-else
                  :index="subItem.name"
                  :key="subItem.name"
                >{{ subItem.meta != null ? subItem.meta.title : '' }}</el-menu-item>
              </template>
            </el-submenu>
          </template>
          <template v-else>
            <el-menu-item :index="item.name" :key="item.name">
              <i :class="item.menuIcon"></i>
              <template #title>{{ item.meta.title }}</template>
            </el-menu-item>
          </template>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>
import defaultSettings from '@/settings'
import {mapGetters} from "vuex";

export default {
  name: "LeftSidebar",
  data(){
    return{
      logoTitle: '',
      menuList: [],            //常规菜单列表
    }
  },
  computed: {
    ...mapGetters([
      'routesLists'
    ]),
    onRoutes() {
      let list = this.$route.path.replace("/", "");
      return list;
    },
  },
  created() {
    this.logoTitle = defaultSettings.title || 'Vue Admin Template'
    this.$nextTick(()=>{
      this.initMenu();       //初始化菜单列表
      // this.getUserInfo();    //获取用户信息
    })
  },
  methods: {
    //选择菜单
    handleSelect(path) {
      this.$router.push(path)
    },
    //初始化菜单列表
    initMenu(){
      for (let i = 0; i < this.routesLists.length; i++) {
        let temp = this.routesLists[i];
        this.menuList.push(temp);
      }
    },
  }
}
</script>

<style scoped>
.el-menu{background-color: #2c306d !important;}
.el-menu{border-right: solid 1px #2c306d;}
.el-menu-item.is-active{background-color: rgba(255,255,255,.08) !important;}
/*.el-menu-item:hover{background-color: rgba(255,255,255,.08) !important;}*/

/deep/.el-menu .el-menu-item:hover{
  outline: 0 !important;
  color: #FFF !important;
  background: rgba(255,255,255,.08) !important;
}
/deep/.el-menu .el-menu-item.is-active {
  color: #FFF !important;
  background: rgba(255,255,255,.08) !important;
}
.el-submenu /deep/.el-submenu__title:hover {
  color: #FFF !important;
  background: rgba(255,255,255,.08) !important;
}
/** 左侧菜单 **/
.el-menu--popup{min-width: 120px!important;}
.el-submenu__icon-arrow{font-size: 14px !important;margin-right: -8px;}
.el-submenu__title{font-size: 14px !important;}

</style>



// WEBPACK FOOTER //
// src/components/theme/theme2/LeftSidebar.vue